





























































import Enumerable from "linq";
import { Component, Mixins, Emit } from "vue-property-decorator";
import {
  FormatReferenceTreeEditDialogModel,
  FormatReferenceTreeAddFormatTreeDialogModel
} from ".";
import { Directory } from "../../../../../domain/drawing";
import { FormatReference } from "../../../../../domain/format";
import { IRectangle } from "../../../../../domain/system";
import { ModelEditableMixin, DialogMixin, PdfStyleDrawableMixin } from "../../../../system/mixins";
import { IGeometryManageable } from "../../../../system/utilities";
import {
  ITreeSource,
  FormatTreeSource,
} from "../sources";
import { FormatReferenceTreeFilterParameter } from "../../../filters";
import FormatReferenceTreeFilter from "../../../filters/FormatReferenceTreeFilter.vue";
import FormatReferenceTreeAddFormatTreeSelector from "./FormatReferenceTreeAddFormatTreeSelector.vue";
import MultiCustomListBoxSelector from "../../../../system/selectors/MultiCustomListBoxSelector.vue";
import Separator from "../../../../system/Separator.vue";
import PdfViewer from "../../../../system/viewers/PdfViewer.vue";

interface IFormatReferenceTreeAddFormatTreeDialogGeometry extends IRectangle {
  formatReferenceTreeAddFormatTreeDialog?: {
    selector: {
      width: number;
    };
  };
}

/**
 * TODO: components/settings/dialogsにほぼ同じ処理があるのでどこかのタイミングで統一したほうが良い
 */
@Component({
  components: {
    FormatReferenceTreeFilter,
    FormatReferenceTreeAddFormatTreeSelector,
    MultiCustomListBoxSelector,
    Separator,
    PdfViewer,
  }
})
export default class FormatReferenceTreeAddFormatTreeDialog extends Mixins(ModelEditableMixin, DialogMixin, PdfStyleDrawableMixin) implements IGeometryManageable<IFormatReferenceTreeAddFormatTreeDialogGeometry> {
  static instanceOfSource(instance: any): instance is FormatReferenceTreeAddFormatTreeDialog {
    return (instance
      && instance.show !== undefined);
  }

  data(): any {
    return {
      result: false,
      formatFilter: new FormatReferenceTreeFilterParameter(),
      treeDialogModel: new FormatReferenceTreeAddFormatTreeDialogModel<FormatReference>(),
      selectorWidth: 800,
      hashTableDirectoryPathForEachFormat: {},
      shouldIgnoreChained: false,
    };
  }
  result: boolean;
  formatFilter: FormatReferenceTreeFilterParameter;
  treeDialogModel: FormatReferenceTreeAddFormatTreeDialogModel<FormatReference>;
  selectorWidth: number;
  hashTableDirectoryPathForEachFormat: { [key: number]: string };
  shouldIgnoreChained: boolean;

  created(): void {
    this.$registerGeometryManager(this);
  }

  destroyed(): void {
    this.$unregisterGeometryManager(this);
  }

  getGeometryNames(isWindowRectangleHandleable: boolean): string[] {
    return [
      "ペイン幅",
    ];
  }

  storeGeomerty(source: IFormatReferenceTreeAddFormatTreeDialogGeometry, isWindowRectangleHandleable: boolean): void {
    source.formatReferenceTreeAddFormatTreeDialog = {
      selector: {
        width: this.selectorWidth,
      },
    };
  }

  restoreGeomerty(source: IFormatReferenceTreeAddFormatTreeDialogGeometry, isWindowRectangleHandleable: boolean): void {
    if (!source.formatReferenceTreeAddFormatTreeDialog) {
      return;
    }
    this.selectorWidth = source.formatReferenceTreeAddFormatTreeDialog.selector.width;
  }

  async show(shouldIgnoreChained: boolean): Promise<void> {
    return this.showModal(async () => {
      this.result = false;
      this.shouldIgnoreChained = shouldIgnoreChained;
      await this.waitHidden();
      if (!this.result) {
        throw new Error();
      }
      this.editDialogModel.addDirectory = this.selectedDirectory.clone();
      this.editDialogModel.addFormats = Enumerable.from(this.selectedFormats)
        .select(r => r.clone())
        .toArray();
    });
  }

  get allFormatTreeSource(): ITreeSource<FormatReference> {
    return new FormatTreeSource(this.shouldIgnoreChained, false);
  }

  get filterFormat(): (source: FormatReference | Directory<string, FormatReference>) => boolean {
    return this.createFormatFilter(this.formatFilter);
  }

  createFormatFilter(source: FormatReferenceTreeFilterParameter): (source: FormatReference | Directory<string, FormatReference>) => boolean {
    return s => source.filter(s);
  }

  get editDialogModel(): FormatReferenceTreeEditDialogModel<FormatReference> {
    return this.editingSource;
  }

  get selectedDirectory(): Directory<string, FormatReference> {
    return this.treeDialogModel.selectedDirectory;
  }

  get selectedFormats(): FormatReference[] {
    return this.treeDialogModel.selectedFormats;
  }

  set selectedFormats(value: FormatReference[]) {
    this.treeDialogModel.selectedFormats = value;
  }

  get selectedOfAllFormats(): FormatReference[] {
    return this.treeDialogModel.selectedOfAllFormats;
  }

  get isSelected(): boolean {
    // return (this.selectedDirectory !== null) || (this.selectedFormats !== null);
    return (this.selectedFormats !== null); // とりあえずフォーマット追加のみ対応
  }

  get options(): FormatReference[] {
    return !!this.selectedOfAllFormats
      ? this.selectedOfAllFormats.slice() // 複製して処理する
      : [];
  }

  get isFormatSelected(): boolean {
    return (this.selectedFormats !== null && this.selectedFormats.length === 1);
  }

  get selectedPreviewSource(): string {
    return (this.isFormatSelected && this.selectedFormats[0].previewSource)
      ? this.selectedFormats[0].previewSource.source
      : "";
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  equivalentValidator(source: FormatReference, destination: FormatReference): boolean {
    return (source === destination) ||
      (source && destination && (source.id === destination.id));
  }

  toLabelClass(row: FormatReference): string {
    return row.expired || row.deleted
      ? "invalid"
      : "";
  }

  toLabel(row: FormatReference): string {
    return row.name;
  }

  toDirector(row: FormatReference): string {
    return this.hashTableDirectoryPathForEachFormat[row.id]
      ? this.hashTableDirectoryPathForEachFormat[row.id]
      : "";
  }

  hashTableDirectoryPathForEachFormatUpdated(value: { [key: number]: string }): void {
    this.hashTableDirectoryPathForEachFormat = value;
  }

  addFormatTree(): void {
    this.result = true;
    this.isVisible = false;
  }

  cancelFormatTree(): void {
    this.isVisible = false;
  }

  @Emit("formatDoubleClicked")
  treeNodeDoubleClicked(): void {}

  @Emit("formatDoubleClicked")
  formatDoubleClicked(): void {}
}
